import React from 'react';
import PropTypes from 'prop-types';

import PermissionsForm from '../../shared/forms/permissions/permissionsForm.component';
import { singleAssignmentPropTypes } from '../../shared/propTypes/userClients';

const RolesPrivilegesGrid = ({
  changePermissions,
  selectedPermissionsFormValue,
  shouldResetValues,
  availablePermissions,
  selectedRole = 'default',
  selectedClient = 'All',
  readOnly,
  getPermissionsFunction,
  checkedAssignments,
  changeAssignmentsPermissions,
  availableAssignmentPermissions,
}) => (
  <div>
    <div>
      <span>Role Privileges</span>
    </div>
    <br />
    <div className="row">
      <div className="col-12 col-md-2">
        <div className="user-client-label">
          {`Client: ${selectedClient?.shortName || 'All'}`}
        </div>
      </div>
    </div>
    <br />
    <PermissionsForm
      getPermissionsFunction={getPermissionsFunction}
      changePermissions={changePermissions}
      selectedPermissionsFormValue={selectedPermissionsFormValue}
      availablePermissions={availablePermissions}
      shouldResetValues={shouldResetValues}
      selectedClient={selectedClient}
      readOnly={readOnly}
      selectedRole={selectedRole}
      checkedAssignments={checkedAssignments}
      changeAssignmentsPermissions={changeAssignmentsPermissions}
      availableAssignmentPermissions={availableAssignmentPermissions}
    />
  </div>
);

RolesPrivilegesGrid.propTypes = {
  changePermissions: PropTypes.func.isRequired,
  selectedPermissionsFormValue: PropTypes.arrayOf(PropTypes.string).isRequired,
  shouldResetValues: PropTypes.bool.isRequired,
  availablePermissions: PropTypes.arrayOf(PropTypes.shape({
    availablePermissions: PropTypes.shape,
  })).isRequired,
  selectedRole: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  selectedClient: PropTypes.shape({
    clientId: PropTypes.number.isRequired,
  }).isRequired,
  readOnly: PropTypes.bool.isRequired,
  getPermissionsFunction: PropTypes.func.isRequired,
  checkedAssignments: PropTypes.arrayOf(singleAssignmentPropTypes).isRequired,
  changeAssignmentsPermissions: PropTypes.func.isRequired,
  availableAssignmentPermissions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    requiresPermissions: PropTypes.arrayOf(PropTypes.string),
  })).isRequired,
};


export default RolesPrivilegesGrid;
